import { h, Component } from 'preact';
import cx from 'classnames';
import dlv from 'dlv';
import { Text } from 'preact-i18n';

import style from './style.less';

import CardImage from '../../pieces/card-image';
import { isExternal, getAttribution } from '../../../lib/utils';

import { trackingProvider, trackProps, getTrackingAttributesForAsset, DIMENSION } from '@cube/track';
import { Truncate, Icon } from '@cube/blocks';
import { assetLink } from '@cube/utils';

/**
 * A card with an image on left and text on right
 * @param {object} asset				the article to display
 * @param {string} theme				light or dark
 * @param {string} cardClass			fully resolved or local class to apply to card
 * @param {string} imageProportion		how much space the image should take up.  values: quarter, third, half
 * @param {integer} titleLines			max number of lines on title
 * @param {boolean} showSummary			display summary
 * @param {integer} summaryLines		max number of lines on summary
 */
@trackingProvider({
	[DIMENSION.componentpath]: 'HorizontalCard'
})
export default class HorizontalCard extends Component {
	state = {
		isHovered: false
	};

	handleMouseEnter = () => {
		this.setState({ isHovered: true });
	};

	handleMouseLeave = () => {
		this.setState({ isHovered: false });
	};

	static defaultProps = {
		imageProportion: 'quarter',
		titleLines: 2,
		showSummary: false,
		summaryLines: 2
	};

	render({ category, asset, theme, cardClass, imageProportion, titleLines, showSummary, openExternal ,summaryLines, qeId, ...props }) {
		return (
			<div data-tb-region-item class={cx(style.horizontalCard, style[imageProportion], style[theme], style[cardClass] || cardClass || '')} qid={qeId}
				onMouseEnter={this.handleMouseEnter}
				onMouseLeave={this.handleMouseLeave}
			>
				<a
					{...trackProps(getTrackingAttributesForAsset(asset), this.context)}
					href={assetLink(asset)}
					rel={(openExternal || isExternal(asset)) && 'noreferrer noopener'}
					target={(openExternal||isExternal(asset)) && '_blank'}
					data-tb-link
				>
					<CardImage
						asset={asset}
						qeId={qeId}
						hover={this.state.isHovered}
						{...props}
					/>
					<div class={style.metadata}>
						<div class={style.title} qid={qeId + '-title'}>
							{(category|| asset?.metadata?.category)&&<span data-tb-category className={style.hidden}>{category || asset?.metadata?.category} </span>}
							<Truncate
								method="multipleLines"
								lines={titleLines}
								data-tb-title
							>
								{asset.title}
							</Truncate>
						</div>
						<div class={style.attribution} qid={qeId + '-attribution'} data-tb-author>
							{getAttribution(asset)}
						</div>
						{ showSummary &&
							<div class={style.summary} qid={qeId + '-summary'} >
								<Truncate
									method="multipleLines"
									lines={summaryLines}
									data-tb-description
								>
									{asset.summary}
								</Truncate>
							</div>
						}
						<div class={style.button}>
							{ dlv(asset, 'videos.0') ?
								[<Text id="watch" data-tb-video />, <Icon name="play-cube" />] :
								[<Text id="read" />, <Icon name="navigate-right-cube" />]
							}
						</div>
					</div>
				</a>
			</div>
		);
	}
}
